import { RouteOfAdminType } from "../../../EMR/components/Prescription/types";

export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  drugDosageForm: string;
  drugRoot: string;
  isTablet: number;
  drugCreatedById: number;
  drugGenericName: string;
  drugPrice: number;
  drugUnit: string;
  drugStatus: number;
  drugCode: string;
  drugPackageName: string;
  drugStrength: string;
  drugCreatedByDate: string;
  clinicId: number;
  drugId: number;
};

export type MasterDataType = {
  drugId: number;
  clinicId: number;
  drugCode: string;
  createdByDate: string;
  createdById: number;
  drugStatus: number;
  drugDosageForm: string;
  drugGenericName: string;
  drugPackageName: string;
  drugPrice: number;
  drugRoot: string;
  drugStrength: string;
  isTablet: number;
  drugUnit: string;
  drugAmount: number;
  dosageUnitCode:string;
  drugRatePackage:number;

};

export type SaveResponseType = {};

export type MasterFormDataType = {
  drugCode: string;
  drugStatus: number;
  drugDosageForm: string;
  drugGenericName: string;
  drugPackageName: string;
  drugPrice: number;
  drugRoot: RouteOfAdminType | null;
  drugStrength: string;
  dosageUnitCode?: string;
  drugPackageRate?: number;

};

export const initialFormData: MasterFormDataType = {
  drugCode: "",
  drugStatus: 1,
  drugDosageForm: "",
  drugGenericName: "",
  drugPackageName: "",
  drugPrice: 0,
  drugRoot: null,
  drugStrength: "",

};
